import styled from 'styled-components'

export const TableRow = styled.tr`
  vertical-align: baseline;
`

export const DatePickerWrapper = styled.div`
  .react-datepicker-wrapper {
    height: 45px;
  }
`
